import React from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import { calculateBarLengthPercent, formatCurrency, getBarChartYLabels } from 'utils';

const ReactTooltip = dynamic(() => import('react-tooltip'), { ssr: false });

const propTypes = {
  xLabels: PropTypes.arrayOf(PropTypes.string),
  values: PropTypes.arrayOf(PropTypes.number),
  yFormatter: PropTypes.func,
  isYStartsZero: PropTypes.bool,
};

const defaultProps = {
  xLabels: [],
  values: [],
  yFormatter: null,
  isYStartsZero: false,
};

const DemographicChart = ({ xLabels, values, yFormatter, isYStartsZero }) => {
  const yLabels = getBarChartYLabels(values, 'desc', 5, isYStartsZero);

  return (
    <div className="salary-demographic-chart">
      <div className="mt-4 bar-chart-container mb-0 position-relative">
        <div className="d-flex flex-column y-labels">
          {yLabels.map((yLabel, idx) => (
            <div
              key={yLabel + idx}
              className="lightTextStyle2 y-label d-flex justify-content-end align-items-center"
            >
              <span>{yFormatter ? yFormatter(yLabel) : formatCurrency(yLabel)}</span>
              <span className="grid-line" />
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-between justify-content-sm-around align-items-end w-100 ml-0 ml-md-5 x-labels">
          {xLabels.map((xLabel, idx) => (
            <div key={xLabel + idx} className="d-flex x-label">
              <div className="label lightTextStyle2">{xLabel}</div>
              <div className="bars">
                <div
                  className="bar"
                  data-place="top"
                  data-tip={`<strong>${formatCurrency(values[idx])}</strong>`}
                  style={{
                    height: `${calculateBarLengthPercent(yLabels, values[idx])}%`,
                  }}
                />
              </div>
            </div>
          ))}
        </div>
        <ReactTooltip html />
      </div>
    </div>
  );
};

DemographicChart.propTypes = propTypes;
DemographicChart.defaultProps = defaultProps;

export default DemographicChart;
